import React from "react"
import { useFormContext, FieldValues, SubmitHandler } from "react-hook-form"

type Data<T extends FieldValues> = Parameters<SubmitHandler<T>>[0]

type AsyncFormProps<T extends FieldValues> = {
    onSubmit: (data: Data<T>) => boolean
    className?: string
    name: string
    dataContentName?: string
}

function Form<T extends FieldValues>({
    className = undefined,
    children,
    name,
    onSubmit,
    dataContentName,
}: React.PropsWithChildren<AsyncFormProps<T>>) {
    const { handleSubmit } = useFormContext<T>()

    return (
        <form name={name} onSubmit={handleSubmit(onSubmit)} className={className} data-content-name={dataContentName}>
            {children}
        </form>
    )
}

export default Form
